import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function RequireSalonContext({ children }) {
  const { user } = useAuth();
  if (!user?.salon_id) {
    return <Navigate to="/login" replace />;
  }
  return children;
}
